import instance from '@/api/business' 
import { MarketResearch, ProductsNotSearched, ResearchCoverage } from '@/types/MarketResearch'
import { 
    CreateMarketResearch, 
    UpdateMarketResearch,
    DeleteMarketResearch,
    InsertProductsInMarketResearchProps, 
    ProductMarketResearch, 
    PDVMarketResearch, 
    DeletProductMarketResearch, 
    ChangeStatusMarketResearch,
    ProductFromPDVMarketResearch,
    CreateResearchedProduct,
    ResearchedProduct,
    DeleteImageResearchedProduct,
    UploadImageResearchedProduct,
    DeleteResearchedProduct,
    MarkProductMarketResearch,
    UpdateResearchedProductProps
} from './type'

const BASE_URL_MARKET_RESEARCH = '/marketresearch/im/marketresearch' 
const BASE_URL_RESEARCHED_PRODUCT = '/marketresearch/im/researchedproduct'
const BASE_URL_PRODUCT = '/marketresearch/im/product'

export const fetchMarketResearch = async () => {
    const response = await instance.post<MarketResearch[]>(BASE_URL_MARKET_RESEARCH)

    return response.data

}

export const fetchMarketResearchById = async (SK_PESQUISA: number) => {
    const response = await instance.post<MarketResearch[]>(`${BASE_URL_MARKET_RESEARCH}byid`,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}

export const createMarketResearch = async (data: CreateMarketResearch) => {
     const response = await instance.put(BASE_URL_MARKET_RESEARCH, data)
 
     return response.data
} 

export const updateMarketResearch = async (data: UpdateMarketResearch) => {
    const response = await instance.patch(BASE_URL_MARKET_RESEARCH, data)

    return response.data
}

export const deleteMarketResearch = async (data: DeleteMarketResearch) => {
    const response = await instance.delete(BASE_URL_MARKET_RESEARCH, {
        data: data,
    })

    return response.data
}

export const changeStatusMarketResearch = async (data: ChangeStatusMarketResearch) => {
    const response = await instance.patch('/marketresearch/im/changestatusmarketresearch', 
        data
    )
    
    return response.data 
}

export const fetchResearchCoverage = async (SK_PESQUISA: number) => {
    const response = await instance.post<ResearchCoverage[]>(`/marketresearch/im/researchcoverage`,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}

export const fetchResearchCoverageProductsNotSearched = async (SK_PESQUISA: number) => {
    const response = await instance.post<ProductsNotSearched[]>(`/marketresearch/im/researchcoverageproductsnotsearched`,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}


export const fetchProductInMarketResearch = async (SK_PESQUISA: number) => {
    const response = await instance.post<ProductMarketResearch[]>(BASE_URL_PRODUCT,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}

export const createProductInMarketResearch = async (data: InsertProductsInMarketResearchProps) => {
    const response = await instance.put(BASE_URL_PRODUCT, data)

    return response.data
}

export const deleteProductInMarketResearch = async (data: DeletProductMarketResearch) => {
    const response = await instance.delete(BASE_URL_PRODUCT,  {
        data: data,
    })
    
    return response.data 
}


export const fetchProductFromPDVInMarketResearch = async (SK_PESQUISA: number, SK_CLIENTE: number) => {
    const response = await instance.post<ProductFromPDVMarketResearch[]>(`/marketresearch/im/productfrompdv`,{
        SK_PESQUISA: SK_PESQUISA,
        SK_CLIENTE: SK_CLIENTE
    })

    return response.data
} 

export const fetchPDVInMarketResearch = async (SK_PESQUISA: number) => {
    const response = await instance.post<PDVMarketResearch[]>(`/marketresearch/im/pdv`,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}


export const createResearchedProduct = async (props: CreateResearchedProduct) => {
    const formData = new FormData();
    
    for (const [key, value] of Object.entries(props)) {
        formData.append(key, value);
    } 

    const res = await instance.put(BASE_URL_RESEARCHED_PRODUCT, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    return res.data;
};

export const updateResearchedProduct = async (data: UpdateResearchedProductProps) => {
    const response = await instance.patch(BASE_URL_RESEARCHED_PRODUCT, {
        ...data
    })

    return response.data 
}

export const fetchResearchedProduct = async (SK_PESQUISA: number) => {
    const response = await instance.post<ResearchedProduct[]>(BASE_URL_RESEARCHED_PRODUCT, {
        SK_PESQUISA: SK_PESQUISA
    })

    return response.data 
}

export const deleteResearchedProduct = async (data: DeleteResearchedProduct) => {
    const response = await instance.delete(BASE_URL_RESEARCHED_PRODUCT,  {
        data: data,
    })
    
    return response.data 
}

export const fetchImageResearchedProduct = async (DS_CHAVE_ARQUIVO: string) => {
    console.log(DS_CHAVE_ARQUIVO)
    const response = await instance.post<{url: string}>('/marketresearch/im/imageresearchedproduct', {
        DS_CHAVE_ARQUIVO: DS_CHAVE_ARQUIVO
    })

    return response.data 
}

export const deleteImageResearchedProduct = async (data: DeleteImageResearchedProduct) => {
    const response = await instance.delete('/marketresearch/im/imageresearchedproduct',  {
        data: data,
    })
    
    return response.data 
}

export const uploadImageResearchedProduct = async (props: UploadImageResearchedProduct) => {
    const formData = new FormData();

    for (const [key, value] of Object.entries(props)) {
        if (value) {
        formData.append(key, value);
        }
    }

    const res = await instance.patch('/marketresearch/im/imageresearchedproduct', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};


export const publishResearchedProduct = async (SK_PRODUTOS_PESQUISADOS: number) => {
    const response = await instance.patch('/marketresearch/im/publishresearchedproduct', {
        SK_PRODUTOS_PESQUISADOS: SK_PRODUTOS_PESQUISADOS
    })

    return response.data 
}


export const fetchMarkProductInMarketResearch = async (SK_PESQUISA: number) => {
    const response = await instance.post<MarkProductMarketResearch[]>('/marketresearch/im/markproduct',{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}